var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.49 9.333h2.944l-.608 5.748a.835.835 0 0 0 .83.92c.262-.001.51-.126.676-.348l5.824-8.32A.834.834 0 0 0 12.49 6H8.887l.6-5.069c.002-.019.003-.078.003-.098A.833.833 0 0 0 8.656 0a.85.85 0 0 0-.681.354L2.823 8a.835.835 0 0 0 .667 1.333"
})));
export default SvgFlash;